import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

const namespaces = ["announcements", "common", "contentCreators", "contentStudio", "courses", "dashboard", "institutions", "students", "teachers", "testPrep", "tenants"] as const;
const supportedLanguages = ["en", "hi"] as const;

void i18n
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`./locales/${language}/${namespace}.json`),
    ),
  )
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: namespaces,
    defaultNS: "common",
    fallbackNS: "common",
    fallbackLng: "en",
    supportedLngs: supportedLanguages as unknown as string[],
    load: "languageOnly",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "digilib_admin_lang",
    },
    react: {
      useSuspense: false,
    },
  });

i18n.on("languageChanged", (language) => {
  document.documentElement.lang = language;
});

export default i18n;
